import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import LoggedMenu from "@/atomic/atoms/LoggedMenu";
import Filter from "@/atomic/organisms/Filters/DebitFilter";
import OrgPayment from "@/atomic/organisms/orgPayment";
import DirectPaymentFooter from "@/atomic/organisms/DirectPaymentFooter";
import LanguageSelector from "@/atomic/atoms/LanguageSelector";
import mobileBackgroundHome from "@/assets/mobile-background-home.jpg";
import deskBackgroundHome from "@/assets/desk-background-home.png";

const getItemData = (item: any) => {
  return {
    plate: item.plate?.replace(
      /^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/,
      "$1-$2",
    ) || "",
    date: item.date,
    status: item.nmPraca || item.status || "Passagem paga",
    price: `R$ ${item.price}`,
    nmConcessionaria: item.nmConcessionaria
  };
};

export default function HomeView({
  goToVehicles,
  items,
  isLoading,
  isShowingMenu,
  toggleMenu,
  plate,
  isVisibleRecharge,
  setIsVisibleRecharge,
  goToRecharge,
  hasVehicles,
  goToBuy,
  debts,
  cart,
  onChangeDebts,
  hasPendingAttemptPayment,
  handleDisablePendingAttemptPayment,
  activeTab,
  onTabChange,
  goToNewCard,
  isAutoPaymentEnabled = true,
  goToNotifications,
  isNotificationsEnabled = false,
}: PropsView) {
  const notificationCount = 2; // TODO: Get from actual notification system

  return (
    <div className="min-h-screen flex flex-col w-full bg-white">
      <div className="absolute top-0 left-0 right-0 w-full h-[calc(280px)]">
        <img
          src={mobileBackgroundHome}
          alt="Background"
          className="absolute block md:hidden object-cover object-[25%_35%] h-[calc(280px)] w-full"
        />
        <img
          src={deskBackgroundHome}
          alt="Background"
          className="absolute hidden md:block object-cover object-[25%_35%] h-[calc(280px)] w-full"
        />
        <div className="absolute inset-0 bg-black/50 w-full" />
      </div>

      <header className="relative z-20 w-full text-white flex items-center pt-8 pb-6">
        <div className="relative w-full flex items-center justify-between max-w-[calc(900px)] px-4 mx-auto">
          <h1 className="text-2xl font-normal text-white">Débitos</h1>
          <div className="flex items-center gap-6">
            <LanguageSelector
              className="text-white"
              arrowImg="/arrow-bottom-white.svg"
              showFlag={true}        
            />
            {isNotificationsEnabled && (
              <button className="relative" onClick={goToNotifications}>
                <img src='/svg/icon-flattened.svg' width={24} height={24} alt="Notificações" />
                
                {notificationCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {notificationCount}
                  </span>
                )}
              </button>
            )}
            <button
              onClick={toggleMenu}
              className="flex items-center justify-center"
            >
              <img src='/svg/icon-menu.svg' width={40} height={40} alt="Menu" />
            </button>
          </div>
        </div>
      </header>
      <main className="relative z-10 flex-1 p-4 w-full flex justify-center text-black h-form">
        <article className="h-full flex flex-col w-full max-w-[calc(480px)]">
          <div className="w-full mt-[calc(89px)] mb-[calc(120px)] pb-[calc(200px)]">
            <div className="flex items-center mb-3">
              <img
                src={"/icon-car.png"}
                width={24}
                height={24}
                alt="icon car"
              />
              <p className="ml-1 text-white font-medium">Seus veículos:</p>
            </div>
            <div className="flex gap-3 mb-6">
              <div className="flex-1 bg-white rounded-xl border border-[#E6E6E6] p-4 flex items-center gap-3 min-h-[calc(81px)]">
                <p className="text-lg font-bold text-black">
                  {Array.isArray(plate) && plate.length > 1
                    ? `${plate.length} placas selecionadas`
                    : Array.isArray(plate) && plate.length > 0 && plate[0]
                    ? plate[0].replace(/^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/, "$1-$2")
                    : typeof plate === 'string' && plate
                    ? plate.replace(/^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/, "$1-$2")
                    : "Nenhuma placa"}
                </p>
              </div>
              <button
                className="bg-white rounded-xl border border-[#E6E6E6] w-[calc(56px)] h-[calc(81px)] flex items-center justify-center flex-shrink-0"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  if (hasVehicles) {
                    goToVehicles(plate);
                  } else {
                    goToBuy();
                  }
                }}
              >
                <img
                  src={"svg/icon-plus.svg"}
                  width={12}
                  height={17}
                  alt="Adicionar veículo"
                />
              </button>
            </div>

            <h2 className="text-base text-black font-semibold mt-6 mb-4">Débitos</h2>
            <Filter onTabChange={onTabChange} isLoading={isLoading} activeTab={activeTab} />

            {activeTab === "pendentes" && (
              <>
                {debts && debts.length > 0 && (
                  <div className="mb-4 mt-7">
                    <div className="flex items-center w-full">
                      <input
                        type="checkbox"
                        name="all"
                        className="w-6 h-6 accent-black"
                        onChange={onChangeDebts}
                        checked={debts?.length === cart?.length}
                      />
                      <p className="text-sm ml-6">
                        {"Selecionar "}
                        {debts?.length} passage
                        {debts?.length !== 1 ? "ns" : "m"} em aberto
                      </p>
                    </div>
                    <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                  </div>
                )}

                {Array.isArray(plate) && plate.length > 0 && debts && debts.length > 0 && (
                  plate.map((currentPlate, plateIndex) => {
                    const plateDebts = debts.filter(debt => debt.plate === currentPlate);

                    return plateDebts.length > 0 ? (
                      <div key={plateIndex} className="mb-4">
                        <div className="flex w-full justify-between items-center py-3 rounded-lg">
                          <p className="text-base uppercase font-bold">
                            {currentPlate.replace(/^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/, "$1-$2")}
                          </p>
                        </div>
                        <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                        {plateDebts.map((item, index) => (
                          <div key={`${currentPlate}-${index}`}>
                            <div className="flex items-center w-full mt-2">
                              <input
                                type="checkbox"
                                name={item.id}
                                className="w-6 h-6 accent-black"
                                onChange={onChangeDebts}
                                checked={
                                  cart?.some(
                                    (selectable) => selectable.name === item.id && selectable.checked
                                  ) ?? false
                                }
                              />
                              <div className="ml-6 w-full">
                                <div className="flex w-full justify-end">
                                  {item?.hasDate && (
                                    <p className="bg-black text-white text-sm p-1 rounded-lg">
                                      {item?.daysLeft > 0 
                                        ? `Vencido há ${item?.daysLeft} dia(s)`
                                        : `Vence em ${item?.dtVencimento}`
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="flex w-full justify-between ">
                                  <p className="text-sm">{item?.fmtDataPassagem || item?.date}</p>
                                  {item?.originalPrice !== item?.price && (
                                    <p className="text-sm line-through">
                                      R$ {item?.originalPrice}
                                    </p>
                                  )}
                                </div>
                                <div className="flex w-full justify-between">
                                  <p className="text-base">
                                    {item?.original?.nmConcessionaria}
                                  </p>
                                </div>
                                <div className="flex justify-between">
                                  <p className="font-bold text-base max-w-72">
                                    {item?.original?.nmPraca}
                                  </p>
                                  <p className="font-bold text-base flex-shrink-0">R$ {item?.price}</p>
                                </div>
                              </div>
                            </div>
                            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                          </div>
                        ))}
                      </div>
                    ) : null;
                  })
                )}
                
                {!isLoading && (!debts || debts.length === 0) && (
                  <div className="w-full flex justify-center items-center flex-col mt-10">
                    <img
                      src={"/svg/icon-vehicle-not-found.svg"}
                      width={48}
                      height={48}
                      alt="Ícone carro"
                      className="mt-6"
                    />
                    <h2 className="mt-4 text-sm text-gray-600 text-center px-8 leading-relaxed">
                      Nenhuma passagem em aberto encontrada. As passagens podem levar até 48 horas para ficarem disponíveis no sistema para pagamento.
                    </h2>
                  </div>
                )}
              </>
            )}

            {activeTab === "pagos" && (
              <>
                {!isLoading && items && items.length > 0 && (
                  <div className="w-full mt-8">
                    <h2 className="text-base text-black mb-4">Histórico de Passagens Pagas</h2>
                    {items?.map((item, index) => {
                      const itemData = getItemData(item);
                      return (
                        <div key={index}>
                          <div className="flex items-center w-full justify-between">
                            <div className="flex flex-col">
                              <p className="text-base uppercase">{itemData.plate}</p>
                              <p className="text-sm">{itemData.date}</p>
                              <p className="text-base">{itemData.nmConcessionaria}</p>
                              <p className="font-bold text-base">
                                {itemData.status}
                              </p>
                            </div>
                            <div className="flex">
                              <p className="font-bold text-base flex-shrink-0">{itemData.price}</p>
                            </div>
                          </div>
                          <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                        </div>
                      );
                    })}
                  </div>
                )}

                {!isLoading && (!items || items.length === 0) && (
                  <div className="w-full flex justify-center items-center flex-col mt-10">
                    <img
                      src={"/svg/icon-vehicle-not-found.svg"}
                      width={48}
                      height={48}
                      alt="Ícone carro"
                      className="mt-6"
                    />
                    <h2 className="mt-4 text-sm text-gray-600 text-center">
                      Nenhuma passagem paga encontrada.
                    </h2>
                  </div>
                )}
              </>
            )}

            {isLoading && <Loading />}
          </div>
        </article>
        {activeTab === "pendentes" && debts && debts.length > 0 && (
          <OrgPayment onClick={goToRecharge} />
        )}
        {activeTab === "pendentes" && (!debts || debts.length === 0) && (
          <DirectPaymentFooter />
        )}
        {activeTab === "pagos" && (
          <DirectPaymentFooter />
        )}
      </main>
      <LoggedMenu isShowingMenu={isShowingMenu} toggleMenu={toggleMenu} />
      {isVisibleRecharge && (
        <Modal
          title="Tudo pronto!"
          messageElement={
            <p className="text-sm text-center text-gray-600">
              Quer cadastrar seu{" "}
              <span className="font-bold">
                Cartão
                <br />
                de Crédito
              </span>{" "}
              e facilitar seus pagamentos.
            </p>
          }
          actionMessage="Cadastrar"
          action={goToNewCard}
          actionSecondMessage="Agora não"
          actionSecond={() => setIsVisibleRecharge(false)}
        />
      )}
      {hasPendingAttemptPayment && isAutoPaymentEnabled && (
        <Modal
          title="Atenção!"
          messageElement={
            <p className="text-sm text-center text-gray-600">
              Não conseguimos processar o pagamento no
              <br />
              cartão cadastrado. Verifique os dados do cartão
              <br />
              e pague manualmente as passagens pendentes.
            </p>
          }
          actionMessage="Voltar"
          action={() => { handleDisablePendingAttemptPayment() }}
          actionClose={() => { handleDisablePendingAttemptPayment() }}
        />
      )}
    </div>
  );
}
